'use strict';
(() => {
  if (window.AwattOriginalPhoneDemo) {
    window.AwattOriginalPhoneDemo.mount(document);
    return;
  }
  const phones = new Map();
  const inlineDemos = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const findRoots = (scope, selector) => {
    const roots = [...scope.querySelectorAll(selector)];
    if (scope.matches?.(selector)) roots.unshift(scope);
    return roots;
  };
  function mountPhone(root) {
    if (phones.has(root)) return;
    const frame = root.querySelector('[data-live-phone-frame]');
    const viewport = root.querySelector('[data-live-phone-viewport]');
    const cover = root.querySelector('[data-live-phone-cover]');
    const status = root.querySelector('[data-live-phone-status]');
    const retry = root.querySelector('[data-live-phone-start]');
    if (!frame || !viewport || !cover) return;
    let started = false;
    let ready = false;
    let visible = false;
    let timeout;
    const pause = () => root.classList.toggle('is-paused', !visible || document.hidden || reducedMotion.matches);
    const resize = () => {
      const width = viewport.clientWidth;
      const height = viewport.clientHeight;
      if (!width || !height) return;
      const scale = Math.min(1, width / 390);
      root.style.setProperty('--aw-live-scale', String(scale));
      root.style.setProperty('--aw-live-height', `${Math.ceil(height / scale)}px`);
    };
    const showRetry = () => {
      if (ready) return;
      if (status) status.textContent = status.dataset.waiting || 'Die Demo lädt noch. Sie können sie erneut laden oder separat öffnen.';
      if (retry) retry.hidden = false;
    };
    const start = (manual = false) => {
      if ((started && !manual) || document.hidden) return;
      started = true;
      ready = false;
      root.classList.remove('is-ready');
      cover.hidden = false;
      frame.hidden = false;
      if (retry) retry.hidden = true;
      if (status) status.textContent = status.dataset.loading || 'Die Original-App wird geladen …';
      resize();
      window.clearTimeout(timeout);
      timeout = window.setTimeout(showRetry, 12000);
      // Only load the original app. Its controls and contents stay untouched.
      frame.src = frame.dataset.demoUrl;
    };
    const loaded = () => {
      if (!started) return;
      ready = true;
      window.clearTimeout(timeout);
      cover.hidden = true;
      root.classList.add('is-ready');
      if (retry) retry.hidden = true;
      if (status) status.textContent = status.dataset.ready || 'Interaktive Original-App · Beispieldaten';
      resize();
    };
    const failed = () => {
      ready = false;
      window.clearTimeout(timeout);
      cover.hidden = false;
      root.classList.remove('is-ready');
      showRetry();
    };
    const onRetry = () => start(true);
    frame.addEventListener('load', loaded);
    frame.addEventListener('error', failed);
    retry?.addEventListener('click', onRetry);
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      visible = entries.some(entry => entry.isIntersecting);
      pause();
      if (visible) start();
    }, { threshold: 0.08 }) : null;
    const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(resize) : null;
    const visibility = () => { pause(); if (visible) start(); };
    observer?.observe(root);
    resizeObserver?.observe(viewport);
    document.addEventListener('visibilitychange', visibility);
    reducedMotion.addEventListener('change', pause);
    window.addEventListener('resize', resize);
    resize();
    if (!observer) { visible = true; pause(); start(); }
    phones.set(root, () => {
      window.clearTimeout(timeout);
      observer?.disconnect();
      resizeObserver?.disconnect();
      frame.removeEventListener('load', loaded);
      frame.removeEventListener('error', failed);
      retry?.removeEventListener('click', onRetry);
      document.removeEventListener('visibilitychange', visibility);
      reducedMotion.removeEventListener('change', pause);
      window.removeEventListener('resize', resize);
      phones.delete(root);
    });
  }
  function mountInlineDemo(demo) {
    if (inlineDemos.has(demo)) return;
    const frame=demo.querySelector('[data-inline-demo-frame]'),cover=demo.querySelector('[data-inline-demo-cover]'),loading=demo.querySelector('[data-inline-demo-loading]'),button=demo.querySelector('[data-inline-demo-start]');if(!frame||!cover||!button)return;let started=false;
    const start=()=>{if(started)return;started=true;if(loading)loading.hidden=false;frame.hidden=false;cover.hidden=true;frame.addEventListener('load',()=>{if(loading)loading.hidden=true;},{once:true});frame.src=frame.dataset.demoUrl;};
    button.addEventListener('click',start);
    // A #demo destination follows an explicit "Demo erleben" link on this site.
    const startAtDestination=()=>{if(window.location.hash==='#demo')start();};window.addEventListener('hashchange',startAtDestination);startAtDestination();
    inlineDemos.set(demo, () => {
      button.removeEventListener('click', start);
      window.removeEventListener('hashchange', startAtDestination);
      inlineDemos.delete(demo);
    });
  }
  function mount(scope) {
    findRoots(scope, '[data-aw-original-live]').forEach(mountPhone);
    findRoots(scope, '[data-inline-demo]').forEach(mountInlineDemo);
  }
  window.AwattOriginalPhoneDemo = { mount };
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    [phones, inlineDemos].forEach(mounted => {
      mounted.forEach((destroy, root) => { if (event.target.contains(root)) destroy(); });
    });
  });
})();
